import { openBlock, createBlock, Transition, withCtx, createElementBlock, renderSlot, createCommentVNode } from "vue";
/* empty css                   */
import _export_sfc from "../../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {
  name: "InputError",
  props: {
    display: {
      type: Boolean,
      default: false
    }
  }
};
const _hoisted_1 = {
  key: 0,
  class: "input-error"
};
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(Transition, { name: "fade" }, {
    default: withCtx(() => [
      $props.display ? (openBlock(), createElementBlock("p", _hoisted_1, [
        renderSlot(_ctx.$slots, "default", {}, void 0, true)
      ])) : createCommentVNode("", true)
    ]),
    _: 3
  });
}
const UikitInputError = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-7a881a0c"]]);
export {
  UikitInputError as default
};
//# sourceMappingURL=InputError.vue.es.js.map
